import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ModelUKMET from "../contents/ModelUKMET";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { draggingCsLegendState } from "../../../store/CsLegendState";
import { weatherTimeWithID, WX_ID_UKMET } from "../../../store/WeatherContentsState";
import { csRevision } from "../../../store/CsRevisionState";
import FlightPathModeState from "../../../store/FlightPathModeState";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  checkLabel: {
    fontSize: 12
  },
  contour:{
    display: 'inline-block',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '35px',
    height: '5px',
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      top: "22px",
      left: 0,
      width: '35px'
    }
  },
  isotach: {
    '&:after': {
      top: 0,
      left: '5px',
      borderTop: '4px solid rgb(7, 206, 255)'
    }
  },
  isotherm: {
    '&:after': {
      top: 0,
      left: '5px',
      borderTop: '4px solid rgb(200, 40, 40)'
    }
  },
  eqvPt: {
    '&:after': {
      top: 0,
      left: '5px',
      borderTop: '4px solid rgb(107, 121, 127)'
    }
  },
  tTd: {
    '&:after': {
      top: 0,
      left: '5px',
      borderTop: '4px solid rgb(200,190,190)'
    }
  },
  vws15: {
    '&:after': {
      borderTop: '4px solid rgb(255, 0, 0)'
    }
  },
  vws12: {
    '&:after': {
      borderTop: '4px solid rgb(255, 255, 0)'
    }
  },
  vws69: {
    '&:after': {
      borderTop: '4px solid rgb(0, 255, 0)'
    }
  },
  tropopause: {
      color: 'rgb(221,0,0)',
      marginLeft: 10
  }
}));

const drawTime = (fpMode, time) => {
  if(fpMode) {
    return <div>{time.baseTime}</div>
  } else {
    return <div>{time.validTime}&nbsp;{time.baseTime}</div>
  }
}

function LegendUKMET({contents: ukmet}) {
  const classes = useStyles();
  const [contentsState, setContentsState] = useState(ukmet.getContentsVisibleState());
  const [allCheck, setAllCheck] = useState(isAllCheck(contentsState));
  const isDragging = useRecoilValue(draggingCsLegendState);
  const setRevision = useSetRecoilState(csRevision);
  const time = useRecoilValue(weatherTimeWithID(WX_ID_UKMET));
  const fpMode = useRecoilValue(FlightPathModeState);
    
  useEffect(() => {
    setAllCheck(isAllCheck(contentsState));
  },[contentsState]);

  const toggleContents = event => {
    if(!isDragging) {
      const name = event.target.name;
      const checked = event.target.checked;
      ukmet.setContentsVisible(name, checked);
      setContentsState({...contentsState, [name]:checked});
      setAllCheck(isAllCheck(contentsState));
      setRevision();
    }
  };
  const changeAllCheck = (event) => {
    if(!isDragging) {
      const checked = event.target.checked;
      const ukmetContentsList = [
        [ModelUKMET.UKMET_EQV_PT],
        [ModelUKMET.UKMET_ISOTACH],
        [ModelUKMET.UKMET_ISOTHERM],
        [ModelUKMET.UKMET_TMINUS_TD],
        [ModelUKMET.UKMET_TROPOPAUSE],
        [ModelUKMET.UKMET_VWS],
        [ModelUKMET.UKMET_WIND]
      ];
      const newState = {};
      ukmetContentsList.forEach(contents => {
        newState[contents] = checked;
        ukmet.setContentsVisible(contents, checked);
      })
      
      setContentsState({...contentsState, ...newState});
      setAllCheck(checked);
      setRevision();
    }
  }
  return (
    <div>
      <div className="legend-contents-time cross-legend-contents-time">
        {drawTime(fpMode, time)}
      </div>
      <div>
        <ul className={classes.box}>
          <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={allCheck} onChange={changeAllCheck} name={ModelUKMET.UKMET_ALL} size='small'/>}
            label={<span className={classes.checkLabel}>ALL</span>}
          />
          </li>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_WIND]} onChange={toggleContents} name={ModelUKMET.UKMET_WIND} size='small'/>}
              label={<span className={classes.checkLabel}>Wind</span>}
            />
          </li>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_ISOTACH]} onChange={toggleContents} name={ModelUKMET.UKMET_ISOTACH} size='small'/>}
              label={
                <>
                  <span className={classes.checkLabel}>Isotach</span>
                  <span className={`${classes.contour} ${classes.isotach}`}/>
                </>
              }
            />
          </li>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_ISOTHERM]} onChange={toggleContents} name={ModelUKMET.UKMET_ISOTHERM} size='small'/>}
              label={
                <>
                  <span className={classes.checkLabel}>Isotherm</span>
                  <span className={`${classes.contour} ${classes.isotherm}`}/>
                </>
              }
            />
          </li>
        </ul>
        <ul className={classes.box}>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_EQV_PT]} onChange={toggleContents} name={ModelUKMET.UKMET_EQV_PT} size='small'/>}
              label={
                <>
                  <span className={classes.checkLabel}>Eqv.PT</span>
                  <span className={`${classes.contour} ${classes.eqvPt}`}/>
                </>
              }
            />
          </li>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_TMINUS_TD]} onChange={toggleContents} name={ModelUKMET.UKMET_TMINUS_TD} size='small'/>}
              label={
                <>
                  <span className={classes.checkLabel}>T-Td &lt; 3℃</span>
                  <span className={`${classes.contour} ${classes.tTd}`}/>
                </>
              }
            />
          </li>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_VWS]} onChange={toggleContents} name={ModelUKMET.UKMET_VWS} size='small'/>}
              label={
                <>
                  <span className={classes.checkLabel}>VWS</span>
                  <span className={`${classes.contour} ${classes.vws15} ${classes.checkLabel}`}>&gt;15</span>
                  <span className={`${classes.contour} ${classes.vws12} ${classes.checkLabel}`}>12</span>
                  <span className={`${classes.contour} ${classes.vws69} ${classes.checkLabel}`}>6-9</span>
                </>
              }
            />
          </li>
        </ul>
        <ul className={classes.box}>
          <li className={classes.item}>
            <FormControlLabel
              control={<Checkbox checked={contentsState[ModelUKMET.UKMET_TROPOPAUSE]} onChange={toggleContents} name={ModelUKMET.UKMET_TROPOPAUSE} size='small'/>}
              label={
                <>
                  <span className={classes.checkLabel}>Tropopause</span>
                  <span className={classes.tropopause}>★</span>
                </>
              }
            />
          </li>
        </ul>
      </div>
    </div>
  )
}

const isAllCheck = (state) => {
  return !Object.values(state).includes(false);
}

export default LegendUKMET;